import BasicObject from '../../BasicObject';
import * as THREE from 'three';
import { COLORS_CONST } from '../../../../helpers/styles';
import { TextObject } from '../../TextObject';
import { DrainLineObject } from '../DrainLineObject';

interface CircleCrossMoveType {
  symbol: string;
}
export class CircleCrossMove extends BasicObject {
  private lineMaterial = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 1 });
  private readonly symbol: string;
  material = new THREE.MeshBasicMaterial({
    color: COLORS_CONST.red,
    transparent: true,
    opacity: 0.4,
  });
  constructor({ symbol }: CircleCrossMoveType) {
    super();
    this.name = 'circle_move';
    this.symbol = symbol;
    this.buildGeometry();
  }

  buildGeometry() {
    super.buildGeometry();
    this.geometry = new THREE.CircleGeometry(DrainLineObject.SizePlane / 2, 32);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
    const rad = 0.3;

    const p1 = new THREE.Vector3(0, this.position.y, -rad);
    const p2 = new THREE.Vector3(0, this.position.y, rad);
    const p3 = new THREE.Vector3(-rad, this.position.y, 0);
    const p4 = new THREE.Vector3(rad, this.position.y, 0);
    this.createCrossLine(p1, p2);
    this.createCrossLine(p3, p4);
    this.createContour();
    const textObject = new TextObject(this.symbol, 0.12);
    textObject.setStartPosition();
    this.add(textObject);
  }
  removeMesh() {
    this.lineMaterial.dispose();
    while (this.children.length > 0) {
      if (this.children[0] instanceof TextObject) {
        this.children[0].removeMesh();
      } else if (
        this.children[0] instanceof THREE.Line ||
        this.children[0] instanceof THREE.LineLoop
      ) {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
        this.remove(this.children[0]);
      } else {
        this.remove(this.children[0]);
      }
    }
    super.removeMesh(this);
  }

  private createContour() {
    const geometry = this.geometry.clone() as THREE.CircleGeometry;
    geometry.vertices.shift();
    const cir = new THREE.LineLoop(geometry, this.lineMaterial);
    this.add(cir);
  }
  private createCrossLine(p1: THREE.Vector3, p2: THREE.Vector3) {
    const geometry = new THREE.Geometry().setFromPoints([p1, p2]);
    const line = new THREE.Line(geometry, this.lineMaterial);
    this.add(line);
  }
}
